module.exports = {
  "view.类型": "Type",
  "view.询价": "quotation request",
  "view.招标": "bidding",
  "view.预计金额": "estimated amount",
  "view.竞标保证金": "Bidding Deposit",
  "view.招标单位": "tendering unit",
  "view.正文内容": "text content",
  "view.截止时间": "Deadline",
  "view.没有找到相关项目": "No related items found",
  "view.欢迎登录信翼通招标网": "Welcome to Cyberwing Tenders",
  "view.请输入账号/手机号": "Please enter your account/mobile phone number",
  "view.请输入密码": "Please enter your password",
  "view.立即登录": "Log in now",
  "view.忘记密码": "forgotten password",
  "view.还没账号？": "Dont have an account yet",
  "view.立即注册": "Register Now",
  "view.请输入": "please type",
  "view.记住密码": "remember password",
  "view.您好，欢迎来到信翼通招标网！": "Hello, welcome to Xinyitong Bidding Network / web",
  "view.登录": "login",
  "view.注册": "Register",
  "view.退出": "Exit",
  "view.认证信息已上传，目前正在审核中，请耐心等待": "Authentication information has been uploaded, currently under review, Please wait patiently.",
  "view.已认证": "accredited",
  "view.工作台": "Workbench",
  "view.信翼通招标网": "Xinyitong Bidding Network",
  "view.搜索": "search",
  "view.首页": "home page ",
  "view.物资项目": "Material items",
  "view.工程项目": "Engineering Projects",
  "view.服务项目": "Services",
  "view.企业认证": "Enterprise Certification",
  "view.营业执照": "business licence",
  "view.营业执照有效期": "Validity of business licence",
  "view.期限类型": "Term type",
  "view.长期": "Long-term",
  "view.固定时间段": "Fixed period",
  "view.请选择开始时间": "Please select a start time",
  "view.请选择结束时间": "Please select an end time",
  "view.是否法人": "Is it a legal entity",
  "view.是": "yes",
  "view.否": "no",
  "view.身份证(正面)": "ID card (front)",
  "view.身份证(反面)": "ID card (back)",
  "view.投标授权委托书": "Bidding authorisation letter",
  "view.重新上传": "re-upload",
  "view.上传附件": "No attachments uploaded",
  "view.下载模版": "Download the template",
  "view.授权委托书有效时间": "Validity time of the power of attorney",
  "view.确 定": "confirm",
  "view.取 消": "Cancel",
  "view.请上传营业执照": "Please upload your business license",
  "view.请选择营业执照有效期": "Please select the validity period of the business license",
  "view.请选择是否法人": "Please select whether it is a legal person",
  "view.请上传身份证(正面)": "Please upload your ID card (front)",
  "view.请上传身份证(反面)": "Please upload your ID card (back side),",
  "view.请上传投标授权委托书": "Please upload the bidding authorization letter",
  "view.请选择授权委托书有效时间": "Please select the validity period of the authorization letter",
  "view.格式有误": "Format error",
  "view.最多上传3个文件": "Up to 3 files can be uploaded",
  "view.投标授权委托书模板.docx": "Tender authorization letter template.docx",
  "view.上传文件不能超过20MB": "Uploaded files cannot exceed 20MB",
  "view.上传文件不能为0KB": "Uploaded files cannot be 0KB",
  "view.上传成功": "Upload successful",
  "view.提交成功": "Submission successful",
  "view.个人认证": "Personal authentication",
  "view.图片预览": "Image preview",
  "view.去认证": "Go authenticate",
  "view.请输入项目名称": "Please enter the project name",
  "view.APP下载": "APP Download",
  "view.信翼通招标系统App": "Xinyitong Tendering System App",
  "view.(仅限安卓版本)": "(Android version only)",
  "view.可使用微信扫一扫扫码下载": "You can use WeChat Scan to download by scanning the QR code",
  "view.上传营业执照副本，仅用于资质审核": "Upload a copy of the business license, only for qualification review",
  "view.业绩": "Performance",
  "view.上传以往业绩合同附件，仅用于资质审核": "Upload the attachments of previous performance contracts, which are only used for qualification review",
  "view.代理许可证": "Agent License",
  "view.提交": "submit",
  "view.询价中": "Inquiry",
  "view.询价项目正在询价中，可以继续报价": "The inquiry project is in progress, you can continue to quote",
  "view.已弃标": "Abandoned bid",
  "view.询价结束": "Inquiry Ended",
  "view.询价项目已结束，可以查看报价记录": "The inquiry project has ended, you can view the quotation record",
  "view.基本信息": "Basic Information",
  "view.招标公告": "Tender Notice",
  "view.标的物信息": "Subject Information",
  "view.序号": "Serial number",
  "view.物资分类": "Material classification",
  "view.物资名称": "Material Name",
  "view.规格": "Specification",
  "view.型号": "model",
  "view.需求数量": "Required quantity",
  "view.计量单位": "Unit of measurement",
  "view.其他": "Remark",
  "view.附件": "appendix",
  "view.标的物附件": "Subject matter attachment",
  "view.投标信息": "Bidding information",
  "view.公司名称/姓名": "Company Name/Name",
  "view.纳税人识别号": "Taxpayer Identification Number",
  "view.联系电话": "Contact phone number",
  "view.联系人": "Contact",
  "view.电子邮件地址": "email address",
  "view.基础文件提交": "Basic file submission",
  "view.未通过原因": "Reason for failure",
  "view.技术要求文件": "Technical requirements document",
  "view.是否符合要求": "Whether it meets the requirements",
  "view.符合": "conform to",
  "view.不符合": "Not compliant",
  "view.请对与技术要求文件不符处进行说明": "Please explain the discrepancies with the technical requirements document",
  "view.供应商技术文件": "Supplier Technical Documents",
  "view.供应商业绩文件": "Supplier Performance Document",
  "view.资质上传": "Qualification upload",
  "view.投标主体": "Bidding entity",
  "view.投标保证金": "Bidding deposit",
  "view.标书费": "Tender Fee",
  "view.已缴纳": "Paid",
  "view.保证金": "Margin",
  "view.缴费日期": "Payment Date",
  "view.缴费凭证": "Payment voucher",
  "view.审核中": "Under review",
  "view.缴费未通过": "Payment failed",
  "view.待缴纳": "To be paid",
  "view.倒计时": "Countdown",
  "view.账号名称": "Account Name",
  "view.对方账户": "Other Account",
  "view.开户行": "Bank",
  "view.缴费结束时间": "Payment end time",
  "view.缴费方式": "Payment method",
  "view.对公转账": "Public transfer",
  "view.招标文件": "Tender documents",
  "view.未提交": "Not submitted",
  "view.递交开始时间": "Submission start time",
  "view.递交结束时间": "Submission end time",
  "view.已超时": "Timed out",
  "view.上传投标文件": "Upload bidding documents",
  "view.请点击按钮上传投标文件，可以在投标截止时问前，修改或撤回投标文件": "Please click the button to upload the bidding documents. You can modify or withdraw the bidding documents before the bidding deadline",
  "view.如果要重新上传投标文件，必须将上次上传的投标文件撤回才可重新上传": "If you want to re-upload the bidding documents, you must withdraw the last uploaded bidding documents before you can re-upload them",
  "view.请充分考虑到传送的时间和自身的网络情况，在投标截止时间前完成投标，逾时传这会被判断为逾期送达": "Please take into full consideration the transmission time and your own network conditions, and complete the bid before the bidding deadline. If you fail to do so, it will be considered as overdue delivery",
  "view.文件名称": "File name",
  "view.投标单位": "Bidding Unit",
  "view.投标负责人": "Bidding Manager",
  "view.上传日期": "Upload date",
  "view.投标文件状态": "Bidding document status",
  "view.操作": "operate",
  "view.查看原因": "View the reason",
  "view.下载": "download",
  "view.撤回投标文件": "Withdraw the tender document",
  "view.已上传的投标文件撤销成功后，请及时重新上传投标文件。务必保证操作历史中最新的为上传成功的记录。": "After the uploaded bidding documents are successfully revoked, please re-upload the bidding documents in time. Make sure that the latest record in the operation history is the successful upload record. ",
  "view.开标报价": "Opening bid",
  "view.报价入口": "Quote entry",
  "view.该投标项目已正式开标。": "The bidding project has been officially opened.",
  "view.该询价项目已开始报价": "The quotation for this inquiry project has started",
  "view.点击报价按钮，前去报价": "Click the quote button to get a quote",
  "view.去报价": "Go to quote",
  "view.报价记录": "Quote Record",
  "view.第": "the",
  "view.轮报价": "Round Quote",
  "view.物料名称": "Material Name",
  "view.预算金额": "Budget amount",
  "view.币种": "Currency",
  "view.含税单价": "Unit price including tax",
  "view.税率": "tax rate",
  "view.物料总价": "Total price of materials",
  "view.其他费用": "Other expenses",
  "view.总价": "Total price",
  "view.结算方式": "Payment Method",
  "view.报价说明": "Quote Description",
  "view.单个体积": "Single volume",
  "view.体积单位": "Volume Unit",
  "view.单个重量": "Single weight",
  "view.重量单位": "Weight unit",
  "view.排名": "Ranking",
  "view.本轮最低价": "The lowest price in this round",
  "view.整体总价": "Total price",
  "view.整体排名": "Overall ranking",
  "view.项目公示": "Project Announcement",
  "view.报价轮次": "Quotation round",
  "view.轮": "wheel",
  "view.报价": "Quote",
  "view.你方": "Your side",
  "view.所递交的": "Submitted",
  "view.投标文件已被我方接受，被确定为中标人。": "The bidding documents have been accepted by us and we have determined you as the successful bidder.",
  "view.中标价": "Winning Bid Price",
  "view.小写": "lower case",
  "view.请你方在接到本通知书后的30日内到": "Please arrive within 30 days after receiving this notice",
  "view.与我方签订": "Signed with us",
  "view.合同协议书": "Contract Agreement",
  "view.退还保证金": "Refund of deposit",
  "view.待退还保证金": "Deposit to be returned",
  "view.已退还保证金": "Deposit has been returned",
  "view.退费凭证": "Refund voucher",
  "view.确认退还": "Confirm refund",
  "view.确认退还倒计时": "Confirm refund countdown",
  "view.报价说明文件": "Quotation Description Document",
  "view.用于上传盖章版报价说明文件，请在最后一次报价结束后上传": "Used to upload the stamped quotation description file, please upload it after the last quotation is completed",
  "view.弃标": "Abandon bid",
  "view.资质审核": "Qualification review",
  "view.缴纳保证金": "Pay security deposit",
  "view.项目标书": "Project Bid",
  "view.投标竞价": "Bidding",
  "view.定标": "Calibration",
  "view.已过提交时间": "Submission time has passed",
  "view.请选择是否符合要求": "Please select whether it meets the requirements",
  "view.请上传供应商技术文件": "Please upload supplier technical documents",
  "view.请上传供应商业绩文件": "Please upload supplier performance files",
  "view.请输入原因": "Please enter the reason",
  "view.请在标书递交开始时间进行递交": "Please submit your bids before the start time",
  "view.请完善信息": "Please complete the information",
  "view.操作成功": "Operation successful",
  "view.保证金是否确认收到": "Is the deposit confirmed to be received",
  "view.提示": "hint",
  "view.确定": "Sure",
  "view.取消": "Cancel",
  "view.是否要放弃该标": "Do you want to give up this bid?",
  "view.请上传缴费证明": "Please upload proof of payment",
  "view.请上传营业执照资质": "Please upload business license qualifications",
  "view.请上传业绩": "Please upload your performance",
  "view.请上传代理许可": "Please upload agent permission",
  "view.请上传": "Please upload",
  "view.是否接受当前结算方式": "Accept current payment method?",
  "view.先款后货": "Payment first",
  "view.先货后款": "Goods first",
  "view.按比例支付": "Payment on a pro rata basis",
  "view.项目类型": "Project Type",
  "view.是否公开询价": "Whether to open inquiry",
  "view.中标方式": "Bidding method",
  "view.分项": "Sub-items",
  "view.整体": "overall",
  "view.联系人/电话": "Contact/Phone",
  "view.询价截止时间": "Quotation deadline",
  "view.付款条件": "Payment terms",
  "view.招标名称": "Tender Name",
  "view.报名开始时间": "Registration start time",
  "view.标书费用": "Tender Fees",
  "view.招标方式": "Bidding method",
  "view.竞价保证金": "Bidding deposit",
  "view.质保期": "Warranty period",
  "view.报名结束时间": "Registration end time",
  "view.投标详情": "Bidding details",
  "view.报价详情": "Quote details",
  "view.缴费": "Payment",
  "view.收起": "retract",
  "view.展开": "expand",
  "view.报价模板": "Quotation Template",
  "view.接受": "Accept",
  "view.不接受": "Do Not Accept",
  "view.开标倒计时": "Bid Opening Countdown",
  "view.本项目开标进入倒计时阶段。请各位投标人提前做好开标相关准备，确保能准时参与开标活动。": "The bid opening for this project has entered the countdown phase. All bidders are kindly requested to make preparations related to the bid opening in advance to ensure timely participation in the activity.",
  "view.物资报价信息": "Material quotation information",
  "view.已开标": "Bid opened",
  "view.备注": "notes",
  "view.当前项目已开标": "The current project has been bid opened",
  "view.投标文件": "bidding documents",
  "view.投标文件类型": "Bid document type",
  "view.商务文件": "Commercial document",
  "view.技术文件": "Technical document",
  "view.由采购部驳回，请修改后重新提交": "Rejected by the procurement department, please revise and resubmit",
  "view.请输入招标项目/招标单位以搜索": "Please enter the bidding project/bidding unit to search",
  "view.项目状态": "Project Status",
  "view.投标状态": "Bidding status",
  "view.查询": "Query",
  "view.招标项目名称": "Tender Project Name",
  "view.招标/询价": "Bidding/Inquiry",
  "view.发布时间": "Release time",
  "view.报名时间": "Registration time",
  "view.投标人": "Bidder",
  "view.查看": "Check",
  "view.处理": "deal with",
  "view.询价中/报价中": "Inquiry/Quotation",
  "view.中标明细": "Bid details",
  "view.中标金额": "Winning bid amount",
  "view.项目名称：": "Project Name:",
  "view.招标单位：": "Tendering unit:",
  "view.发布时间：": "Release time:",
  "view.开始日期": "start date",
  "view.结束日期": "End Date",
  "view.重置": "Reset",
  "view.我的关注": "My attention",
  "view.详情": "Details",
  "view.删除": "delete",
  "view.是否取消关注该项目": "Do you want to unfollow this project?",
  "view.删除成功": "Deleted successfully",
  "view.请输入招标项目名称以搜索": "Please enter the name of the bidding project to search",
  "view.请输入单位名称名称以搜索": "Please enter the unit name to search",
  "view.项目状态：": "Project status:",
  "view.提交日期：": "Submission date:",
  "view.提交人：": "Submitted by",
  "view.我的问题": "My problem",
  "view.新增": "Add",
  "view.单位名称": "Unit Name",
  "view.提交时间": "Submission time",
  "view.提交人": "Submitted by",
  "view.提交人联系电话": "Submitter's contact number",
  "view.状态": "state",
  "view.草稿": "draft",
  "view.提交未回复": "Submit no reply",
  "view.已回复": "Replied",
  "view.是否删除该信息?": "Do you want to delete this information?",
  "view.是否提交该信息?": "Do you want to submit this information?",
  "view.问题详情": "Problem details",
  "view.请输入关键词": "Please enter keywords",
  "view.提问单位名称": "Name of the unit in question",
  "view.问题描述": "Problem description",
  "view.提 交": "submit",
  "view.保 存": "save",
  "view.问题回复": "Question reply",
  "view.问题回复情况": "Question response status",
  "view.问题回复人": "Question Respondent",
  "view.回复时间": "Response time",
  "view.个人信息": "personal information",
  "view.姓名": "Name",
  "view.登录账号": "Login account",
  "view.纳税人识别号(身份证号)": "Taxpayer Identification Number (ID Number)",
  "view.电子邮箱": "Email",
  "view.保存": "save",
  "view.保存成功": "Save successfully",
  "view.个人中心": "Personal Center",
  "view.我的投标": "My Bid",
  "view.密码修改": "Password change",
  "view.处理事项": "Handling Matters",
  "view.旧密码": "Old Password",
  "view.新密码": "New Password",
  "view.确认密码": "Confirm Password",
  "view.密码不一致": "Passwords do not match",
  "view.修改成功": "Modification successful",
  "view.是否提交投标文件": "Submit bidding documents",
  "view.支付比例": "Payment ratio",
  "view.本轮报价": "Current round of quotation",
  "view.下载模板": "Download template",
  "view.导入": "Import",
  "view.每轮次单价降价幅度比上一轮单价低": "The price reduction in each round is lower than that in the previous round",
  "view.元": "Yuan",
  "view.预付款": "Prepayment",
  "view.发货款": "Shipping payment",
  "view.到货款": "Payment upon delivery",
  "view.到货检验款": "Arrival inspection fee",
  "view.设备安装费": "Equipment installation fee",
  "view.项目检验费用": "Project inspection fee",
  "view.质保": "Warranty",
  "view.单价": "unit price",
  "view.请完善": "Please complete",
  "view.信息": "information",
  "view.导入中": "Importing",
  "view.导入成功": "Import successful",
  "view.操作失败": "Operation failed",
  "view.询价单位": "Inquiry Unit",
  "view.商务联系人/电话": "Business contact/telephone",
  "view.分项中标": "Sub-item winning bid",
  "view.整体中标": "Overall winning bid",
  "view.投标方式": "Bidding method",
  "view.现场招标": "On-site bidding",
  "view.线上招标": "Online Bidding",
  "view.技术联系人/电话": "Technical contact/telephone",
  "view.开标时间": "Tender opening time",
  "view.整体排名：当前排名第": "Overall ranking: Currently ranked as",
  "view.财务成本价": "Financial cost price",
  "view.当前最低价": "The current lowest price",
  "view.当前最高价": "The current highest price",
  "view.距离报价结束：": "Waktu tersisa hingga penawaran berakhir:",
  "view.上一轮": "Putaran sebelumnya",
  "view.每轮次报价降价幅度比上一轮报价低": "Each round's price reduction must be lower than the previous round's price.",
  "view.每轮次报价上涨幅度比上一轮报价高": "Each round's price increase must be higher than the previous round's price.",
  "view.每轮次报价降价幅度比全场最低价低": "Each round's price reduction must be lower than the lowest price in the entire auction.",
  "view.每轮次报价上涨幅度比全场最高价高": "Each round's price increase must be higher than the highest price in the entire auction.",
  "view.技术附件": "Technical Annex",
  "view.项目总预算：": "Total Project Budget:",
  "view.预算总价": "Total Budget Price",
  "view.预算单价": "Unit Budget Price",
  "view.是否含税": "Tax inclusive",
  "view.标段信息": "Lot information",
  "view.报价（含税）": "Quotation (tax inclusive)",
  "view.系数": "Coefficient",
  "view.总价（含税）": "Total price (tax inclusive)",
  "view.请确认": "Please confirm ",
  "view.真实报价是否为0，若不对该标的物进行报价，则空置不填": "Is the actual quotation 0? If no quotation is given for the subject matter, it will be left blank",
  "view.标段": "Lot",
  "view.数量": "Quantity",
  "view.报价方式": "Quotation method",
  "view.限价": "Price limit",
  "view.系数名称": "Coefficient name",
  "view.币种单位": "Currency unit",
  "view.询价要求文件": "Inquiry Request Document",
  "view.标的物附件：": "Subject matter attachment:",
  "view.已关注": "Already concerned",
  "view.关注": "focus on",
  "view.参与询价": "Participate in the inquiry",
  "view.报名成功": "Registration successful",
  "view.关注成功": "Focus on success",
  "view.无": "None",
  "view.期望到货日期": "Expected Arrival Date",
  "view.标段名称": "Bid Section Name",
  "view.取消关注成功": "Unsubscribed successfully",
  "view.建设单位": "construction unit",
  "view.收费信息": "Charge information",
  "view.金额": "Amount",
  "view.账号": "account",
  "view.投标人资质要求": "Qualification requirements for bidders",
  "view.报名": "Sign up",
  "view.返回首页": "Return to the homepage",
  "view.密码重置": "Password reset",
  "view.进行身份验证": "Authentication",
  "view.重新设置密码": "Reset password",
  "view.完成密码重置": "Complete password reset",
  "view.邮箱地址": "Email address",
  "view.图形验证": "Graphic Verification",
  "view.请计算得出验证码结果": "Please calculate the verification code result",
  "view.邮箱验证": "Email Verification",
  "view.请输入邮箱收到的验证码": "Please enter the verification code received in your email",
  "view.重置密码": "Reset password",
  "view.请输入再次输入新密码": "Please enter your new password again",
  "view.修改": "Revise",
  "view.密码重置成功": "Password reset successful",
  "view.您的密码已重置成功，请牢记新密码！": "Your password has been reset successfully, please remember the new password! ",
  "view.已有账号？": "Already have an account? ",
  "view.去登录": "Go to login",
  "view.两次输入的密码不一致": "The two passwords you entered do not match",
  "view.邮箱格式有误": "The email format is incorrect",
  "view.手机号码不能为空": "Mobile phone number cannot be empty",
  "view.请输入正确的手机号码": "Please enter a valid mobile phone number",
  "view.密码强度不够(数字、大小写、特殊字符组成)": "The password is not strong enough (numbers, uppercase and lowercase letters, special characters)",
  "view.获取验证码": "Get verification code",
  "view.请选择": "Please select",
  "view.请输入您的密码": "Please enter your password",
  "view.用户密码长度必须介于 5 和 20 之间": "User password length must be between 5 and 20",
  "view.短信验证": "SMS Verification",
  "view.手机号码": "Phone Number",
  "view.请输入短信收到的验证码": "Please enter the verification code received via SMS",
  "view.招询公告": "Inquiry Announcement",
  "view.招标项目": "Tender Project",
  "view.更多": "More",
  "view.预计金额：": "Estimated amount:",
  "view.询价项目": "Inquiry Item",
  "view.欢迎注册信翼通招标网": "Welcome to register Xinyitong Bidding Network",
  "view.单位注册": "Unit registration",
  "view.个人注册": "Personal registration",
  "view.企业名称": "Company Name",
  "view.密码": "password",
  "view.身份证": "ID card",
  "view.邮箱": "Mail",
  "view.邮箱验证码": "Email verification code",
  "view.主营业务": "Main business",
  "view.为了更精确投标业务，请填写主营业务": "In order to bid more accurately, please fill in the main business",
  "view.我已阅读并同意": "I have read and agree",
  "view.《招标网平台会员注册须知》": "《Bidding Network Platform Member Registration Instructions》",
  "view.《招标网平台法律声明》": "Legal Statement of Bidding Network Platform",
  "view.手机号格式有误": "The mobile phone number format is incorrect",
  "view.请勾选注册须知": "Please check the registration instructions",
  "view.填写企业信息": "Fill in enterprise information",
  "view.信息审核中": "Information under review",
  "view.身份认证通过": "Identity verification passed",
  "view.公司信息": "Company information",
  "view.供应商名称": "Supplier name",
  "view.供应商简称": "Supplier abbreviation",
  "view.供应商地址": "Supplier address",
  "view.供应商类别": "Supplier category",
  "view.企业类型": "Enterprise type",
  "view.生产地址": "Production address",
  "view.生产规模/产能（台套）": "Production scale/capacity (sets)",
  "view.代理商资质": "Agent qualification",
  "view.产品生产资质": "Product production qualification",
  "view.纳税性质": "Tax nature",
  "view.实缴资本": "Paid-in capital",
  "view.注册地址": "Registered address",
  "view.注册资金": "Registered capital",
  "view.职工人数": "Number of employees",
  "view.厂房面积": "Factory area",
  "view.年营业额": "Annual turnover",
  "view.公司成立日期": "Date of establishment",
  "view.三年财报": "Three-year financial statements",
  "view.经营范围": "Business scope",
  "view.供应产品名称(产品类别、主营产品)": "Supplied product name (product category, main products)",
  "view.产品出厂检测标准": "Product inspection standard before leaving the factory",
  "view.是否经我司试用": "Whether it has been trialed by our company",
  "view.供货产品信息": "Supply Product Information",
  "view.供应产品名称": "Supplied Product Name",
  "view.产品是否经过我司试用": "Whether the product has been trialed by our company",
  "view.请添加供货产品信息": "Please add supply product information",
  "view.请输入产品": "Please enter the product",
  "view.营业信息": "Business information",
  "view.法定代表人": "Legal representative",
  "view.法人代表身份证明": "Legal representative's identity certificate",
  "view.下载样例": "Download sample",
  "view.至": "to",
  "view.点击上传": "Click to upload",
  "view.文件地址不存在": "File address does not exist",
  "view.该格式不支持在线预览，已下载文件": "This format cannot be previewed online. The file has been downloaded.",
  "view.投标人信息": "Bidder information",
  "view.联系方式": "Contact information",
  "view.委托书有效期 ": "Validity period of the letter of authorization",
  "view.开户信息": "Account opening information",
  "view.银行账号": "Bank account number",
  "view.开户银行": "Bank name",
  "view.是否进行企业认证": "Whether to Conduct Enterprise Certification",
  "view.护照": "passport",
  "view.法人代表身份证明（正面）": "Legal representative's identity certificate (front)",
  "view.法人代表身份证明（反面）": "Legal representative's identity certificate (back)",
  "view.大于当前系统时间": "Greater than the current system time",
  "view.开始时间不得大于结束时间": "The start time cannot exceed the end time",
  "view.填写个人信息": "Fill in personal information",
  "view.下一步": "Next step",
  "view.上一步": "Previous step",
  "view.信息反馈": "Information feedback",
  "view.请在企业信息内完善法人身份证信息": "Please complete the legal representative's ID card information in the enterprise information",
  "view.开户行号": "Bank Code",
  "view.供货类型及品牌": "Supply Type and Brand",
  "view.添加": "Add",
  "view.供货类型": "Supply Type",
  "view.品牌": "Brand",
  "view.业务联系人": "Business Contact",
  "view.人员类型": "Personnel Type",
  "view.请选择人员类型": "Please select personnel type",
  "view.请添加业务联系人": "Please add business contact",
  "view.电话": "Phone",
  "view.单位管理人": "Company Administrator",
  "view.合同签订人": "Contract Signatory",
  "view.采购业务员": "Procurement Officer",
  "view.请添加供货类型及品牌信息": "Please add supply type and brand information",
  "view.招标联系人": "Bidding Contact",
  "view.选择人员": "Select Personnel",
  "view.选择招标联系人": "Select Bidding Contact",
  "view.正常": "Normal",
  "view.停用": "Deactivated",
  "view.上传失败": "Upload failed",
  "view.审批驳回": "Approval Rejected",
  "view.审批中": "Under Approval",
  "view.审核通过": "Approved",
  "view.物资编码": "Material Code",
  "view.来源": "Source",
  "view.合同名称/招标项目": "Contract Name/Tender Project",
  "view.商品信息": "Product Information",
  "view.采购/招标负责人": "Procurement/Tender Responsible Person",
  "view.驳回原因": "Rejection Reason",
  "view.完善信息": "Improve Information",
  "view.物资名称-信息填写": "Material Name - Information Filling",
  "view.是否进口": "Imported or Not",
  "view.商品介绍": "Product Introduction",
  "view.商品主图(包含图片、3D建模、视频等)": "Product Main Image(Including images, 3D modeling, videos, etc)",
  "view.批量提交": "Batch Submit",
  "view.请选择要提交的数据": "Please Select the Data to Submit",
  "view.物资名称-信息查看": "Material Name - Information Viewing",
  "view.查看信息": "View Information",
  "view.选择物资": "Select Material",
  "view.供应商": "Supplier",
  "view.请输入物资编码": "Please enter the material code",
  "view.请输入物资名称": "Please enter the material name",
  "view.请输入规格": "Please enter the specification",
  "view.请输入型号": "Please enter the model",
  "view.请选择一条物资信息": "Please select one material",
  "view.模板.xlsx": "template.xlsx",
  "view.业绩文件": "Performance Documents",
  "view.代理许可": "Agent License",
  "view.报价文件": "Quotation Documents",
  "view.投标项目": "bidding project",
  "view.驳回信息": "Reject information",
  "view.信息审核驳回": "Information review rejected",
  "view.物资/项目": "Materials/Projects",
  "view.企业类别": "Jenis Perusahaan",
  "view.国内供应商": "Pemasok Dalam Negri",
  "view.印尼供应商": "Pemasok Indonesia",
  "view.转为印尼供应商": "Jadi Pemasok Indonesia",
  "view.转为国内供应商": "Jadi Pemasok Dalam Negri",
  "view.企业信息": "Corporate Information",
  "view.是否转为国内供应商": "Whether to switch to a domestic supplier",
  "view.备件信息完善": "Spare Part Information Completion",
  "view.招标项目/招标单位": "Tendering Project / Tendering Unit",
  "view.招标负责人": "Tendering Person in Charge",
  "view.备件信息完善详情": "Details of Spare Part Information Completion",
  "view.物资信息": "Material Information",
  "view.备件信息": "Spare Part Information",
  "view.备件名称": "Spare Part Name",
  "view.更换周期": "Replacement Cycle",
  "view.主图": "Main Image",
  "view.请添加备件信息": "Please Add Spare Part Information",
  "view.投标授权委托书过期提醒": "Reminder of Bid Power of Attorney Expiration",
  "view.注：距离投标授权委托书过期还有": "Note: There are still",
  "view.天": "days",
  "view.请尽快重新上传": "Please re-upload as soon as possible",
  "view.投标授权委托书已过期，请尽快重新上传": "The bid power of attorney has expired, please re-upload it as soon as possible",
  "view.授权委托书管理": "Power of Attorney Management",
  "view.审批通过时间": "Approval Pass Time",
  "view.变更授权委托书": "Change Power of Attorney",
  "view.授权委托书已上传，目前正在审核中，请耐心等待": "The power of attorney has been uploaded and is currently under review. Please be patient",
  "view.请输入本人真实姓名": "Please enter your real name",
  "view.您的问题已提交，运营人员将会与您联系": "Your question has been submitted, and our operators will contact you shortly",
  "view.返回": "return",
  "view.变更供货类型": "Change Supply Type",
  "view.项目信息": "Project Information",
  "view.变更申请记录": "Change Application Record",
  "view.项目名称": "Project Name",
  "view.提交日期": "Submission Date",
  "view.处理人": "Handler",
  "view.处理时间": "Processing Time",
  "view.贵单位供货类型信息与当前项目物资分类": "Your company's supply type information and current project material classification",
  "view.不符，请确认是否符合招标要求并继续报名。": "There is a discrepancy. Please confirm compliance with the bidding requirements before proceeding with registration.",
  "view.检测到贵企业有正在审批的企业信息变更申请，请等待变更流程审批完成、企业信息更新生效后，再重新提交报名。": "We have detected that your company has an application for changing enterprise information that is currently being approved. Please wait until the approval process is completed and the enterprise information update takes effect before resubmitting your application.",
  "view.物料编码": "Material Code",
  "view.价格类型":'price type',
  "view.报名状态":'Registration Status',
  "view.待完善价格":'Price to be improved',
  "view.待审核":'Pending review',
  "view.报名失败":'Registration failed',
  "view.价格审批驳回":'Price approval rejected',
  "view.价格审批中":'Price approval in progress',
  "view.选择":'choose',

}